import { Braces, FileText, Globe, History, KeyRound, MessageSquare, Palette, Users, UserSearch } from 'lucide-react'
import { FC, useEffect } from 'react'
import { Route } from 'react-router'
import r from 'routes'

import SettingsLayout from '@/components/layout/settings/layout'
import useEnforceRole from '@/hooks/useEnforceRole'
import AdminManagement from '@/pages/settings/admin-management'
import AuditLog from '@/pages/settings/audit-log'
import Branding from '@/pages/settings/branding'
import CustomerLookup from '@/pages/settings/customer-lookup'
import Domain from '@/pages/settings/domain'
import SettingsLogging from '@/pages/settings/logging'
import SMSConfiguration from '@/pages/settings/sms-configuration'
import app from '@/slices/app'
import { useAppDispatch } from '@/store'

import Developers from './developers'
import SingleSignOn from './single-sign-on'

const links = [
  { path: r.settings.branding, title: 'Branding', icon: Palette },
  { path: r.settings.domain, title: 'Domain', icon: Globe },
  { path: r.settings.adminManagement, title: 'Admin Management', icon: Users },
  { path: r.settings.smsConfiguration, title: 'SMS Configuration', icon: MessageSquare },
  { path: r.settings.customerLookup, title: 'Customer Lookup', icon: UserSearch },
  { path: r.settings.singleSignOn, title: 'Single Sign-On', icon: KeyRound },
  { path: r.settings.logging, title: 'Logging', icon: FileText },
  { path: r.settings.auditLog, title: 'Audit log', icon: History },
  { path: r.settings.developers, title: 'Developers', icon: Braces },
]

const GeneralSettings: FC = () => {
  useEnforceRole('admin', r.root)

  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(app.actions.setApp(undefined))
  }, [dispatch])

  return (
    <SettingsLayout links={links}>
      <Route path={r.settings.branding} Component={Branding} />
      <Route path={r.settings.domain} Component={Domain} />
      <Route path={r.settings.adminManagement} Component={AdminManagement} />
      <Route path={r.settings.smsConfiguration} Component={SMSConfiguration} />
      <Route path={r.settings.customerLookup} Component={CustomerLookup} />
      <Route path={r.settings.singleSignOn} Component={SingleSignOn} />
      <Route path={r.settings.logging} Component={SettingsLogging} />
      <Route path={r.settings.auditLog} Component={AuditLog} />
      <Route path={r.settings.developers} Component={Developers} />
    </SettingsLayout>
  )
}

export default GeneralSettings
